var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Popup',{attrs:{"position":"bottom"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('datetime-picker',{attrs:{"value":_vm.currentData,"type":"date","min-date":_vm.minDate,"max-date":_vm.maxDate,"title":_vm.title},on:{"confirm":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }